<div class="component-blog-view">
  <div class="component-blog-view__top-bar">
    <app-list-grid-trigger></app-list-grid-trigger>
  </div>
  <app-right-view></app-right-view>
</div>
